import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  BoxExtendedProps,
  costFormater,
  NavigationLeftIcon,
  RawButton,
  Text,
  useResponsive,
} from '@common-fe/common-fe';

import { useGetFundIcon } from '../hooks';
import { CategoryStockItem } from '../hooks/useInvestmentsHoldings';

interface PreviewFieldProps extends BoxExtendedProps {
  title: string;
  children: React.ReactNode;
}
const FundPreviewField: React.FC<PreviewFieldProps> = ({ children, title, ...props }) => {
  return (
    <Box direction="row" justify="between" align="center" {...props}>
      <Text size="large" weight={400} color="textSecondary">
        {title}
      </Text>
      {children}
    </Box>
  );
};

interface Props {
  item?: CategoryStockItem | null;
  onClose: () => void;
}
const FundsDetailsModal: React.FC<Props> = ({ item, onClose }) => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  const handleGetFundIcon = useGetFundIcon();
  const handleOpenLink = () => {
    window.open(item?.researchURL, '_blank');
  };
  if (isMobile && item) {
    return (
      <Box
        pad={{ vertical: 'spacing24' }}
        background="canvas"
        style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 999 }}
      >
        <Box>
          <RawButton onClick={onClose}>
            <Box align="center" pad={{ horizontal: 'spacing8' }} direction="row">
              <Box justify="center" width="48px" height="48px" align="center">
                <NavigationLeftIcon color="navigationAccent" size="18px" />
              </Box>
              <Text color="textAccent">{t('Fund details')}</Text>
            </Box>
          </RawButton>
        </Box>
        <Box margin={{ top: 'spacing12' }}>
          <Box pad="spacing16" round="container3Round" background="module">
            <Box
              round="moduleRound"
              pad="spacing16"
              background="canvas"
              direction="column"
              border={{ size: 'small', color: 'border2' }}
            >
              <Box direction="row">
                {handleGetFundIcon({
                  image: item.logo,
                  size: '48px',
                  // status: status,
                  isGreyMode: false,
                  isNullMode: true,
                })}
                <Box direction="column" margin={{ left: 'spacing8' }}>
                  <Text size="xxlarge" weight={700}>
                    {item.title}
                  </Text>
                  <Text size="large" weight={400}>
                    {item.ticker}
                  </Text>
                </Box>
              </Box>
              <Box margin={{ vertical: 'spacing16' }} height="1px" background="border1"></Box>
              <Box gap="spacing8">
                <FundPreviewField title={t('Balance')}>
                  <Text size="2xl" color="textAccent" weight={700}>
                    {costFormater(item.value || 0, {
                      isPrecision: true,
                    })}
                  </Text>
                </FundPreviewField>
                <FundPreviewField title={t('Category')}>
                  <Box align="center" direction="row" margin={{ left: 'spacing12' }}>
                    <Box width="8px" height="8px" round="2px" background={item.color} />
                    <Text
                      size="large"
                      title={item.categoryTitle}
                      weight={700}
                      truncate
                      margin={{ left: 'spacing8' }}
                    >
                      {item.categoryTitle}
                    </Text>
                  </Box>
                </FundPreviewField>
                <FundPreviewField title={t('Shares')}>
                  <Text size="large" weight={700}>
                    {item.shares}
                  </Text>
                </FundPreviewField>
                <FundPreviewField title={t('Share price')}>
                  <Text size="large" weight={700}>
                    {costFormater(item.sharePrice || 0, {
                      isPrecision: true,
                    })}
                  </Text>
                </FundPreviewField>
                <FundPreviewField title={t('Election')}>
                  <Text size="large" weight={700}>
                    {item.election}%
                  </Text>
                </FundPreviewField>
                {item.researchURL && (
                  <RawButton onClick={handleOpenLink}>
                    <Box
                      height="48px"
                      round="button1Round"
                      background="buttonTertiaryHover"
                      direction="row"
                      align="center"
                      justify="center"
                    >
                      <Box direction="row">
                        <Text>{t('Show Research')}</Text>
                      </Box>
                    </Box>
                  </RawButton>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }
  return null;
};

export default FundsDetailsModal;
